import React from "react";

export default function MySQL_LN() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">MySQL_LN</h1>
      <p>This is the MySQL_LN component generated from the SQL JSON.</p>
    </div>
  );
}
